import React, { useState } from 'react';
import './delete.user.css';
import { DrugExceptionsClient } from '../../../client/drug-exceptions-client';
import { TextField } from '@mui/material';
interface HandleError {
    handleError: Function;
}
export default function DeleteUser(props: HandleError) {
    const userId = JSON.parse(sessionStorage.getItem('userId') || 'null');
    const userIdentityObject = JSON.parse(sessionStorage.getItem('userIdentityObject') || 'null');
    const client = new DrugExceptionsClient();
    const drugExceptionsClient = new DrugExceptionsClient();

    const [email, updateEmail] = useState('');
    const [result, updateResult] = useState('');

    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        updateEmail((event.target as HTMLInputElement).value);
    };


    const deleteUser = async() => {
        try {
            if (userId) {
                const token = userId.authToken;
                const id = userId.id;
                if (token && id) {

                    const deleteUserResponse = await drugExceptionsClient.api.delete('/claimants/deletebyemail', {
                        headers: {
                            Authorization: `Bearer ${token}`
                        },
                        params: {
                            email
                        }
                    });

                    updateResult(`${deleteUserResponse.data.numUsersDeleted} users deleted`);
                }
            }

        } catch(error) {
            props.handleError(error);
        }
    };

    return (
        <div className="delete-user-container">
            <div className='header'>
                <h1>Delete User</h1>
            </div>
            <div className="inputs">
                <TextField
                    id="medical-condition-input"
                    label="Email"
                    defaultValue={email}
                    onChange={handleEmailChange}
                    variant="filled"
                    margin="normal"
                />
                <button className="mdc-button mdc-button--raised mdc-ripple-upgrade button-shaped" onClick={deleteUser}>
                    <div className="mdc-button__ripple"></div>
                    <span className="mdc-button__label">Delete user</span>
                </button>
                <p>{result}</p>
            </div>
        </div>
    );
}